import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { compose } from 'redux';
import { useQuery } from 'react-apollo';
import qs from 'query-string';

import useAuthenticated from '../../hooks/useAuthenticated';
import { MeQuery } from '../../graphql/queries/account';
import FullScreenLoader from '../global/FullScreenLoader';
import { getDefaultBasenameForAccount } from '../../util/account';

const WithUnauthentication = (WrappedComponent, options = {}) => props => {
  const authenticated = useAuthenticated();
  const { data: { me: user } = {}, loading: loadingUser } = useQuery(MeQuery, {
    skip: !authenticated,
  });
  const location = useLocation();
  const searchQuery = qs.parse(location.search);

  const { redirectUrl = '/app', getRedirectUrl } = options;

  if (authenticated && loadingUser) {
    return <FullScreenLoader />;
  }

  if (authenticated && getRedirectUrl) {
    const basename = getDefaultBasenameForAccount(user);

    return <Redirect to={getRedirectUrl({ user, basename, searchQuery })} />;
  }

  return !authenticated ? (
    <WrappedComponent {...props} />
  ) : (
    <Redirect to={redirectUrl} />
  );
};

export { WithUnauthentication };

export default (WrappedComponent, options) => {
  return compose(WithUnauthentication)(WrappedComponent, options);
};
